import styled from 'styled-components'
import { ReactComponent as CheckmarkIcon } from '../../assets/checkmark.svg'

export default styled(CheckmarkIcon)`
  fill: ${props => props.theme.colors.green3};
  height: 10px;
`
